import { productService as firebaseProductService } from './firebaseService';


export const productService = {
  // Get latest products for homepage
  getLatestProducts: async (limit = 6) => {
    try {
      return await firebaseProductService.getLatestProducts(limit);
    } catch (error) {
      console.error('Error fetching latest products:', error);
      throw error;
    }
  },

  // Get all products with pagination
  getAllProducts: async (page = 0, size = 12) => {
    try {
      return await firebaseProductService.getAllProducts(size);
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  // Get product by ID
  getProductById: async (id) => {
    try {
      return await firebaseProductService.getProductById(id);
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  // Search products
  searchProducts: async (query, page = 0, size = 12) => {
    try {
      return await firebaseProductService.searchProducts(query, size);
    } catch (error) {
      console.error('Error searching products:', error);
      throw error;
    }
  }
};